import React from "react";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import i18n from "../../../../constants/i18n";
import Et3Table from "../../../../core/et3-table";
import getMyAuditingPerformanceStore from "../../../../stores/auditor-store/my-auditing-performance-store";
import {
  AUDITOR_MY_AUDITING_PERFORMANCE_EFFICIENCY,
  AUDITOR_MY_AUDITING_PERFORMANCE_HEADERS
} from "../../../../constants/table-custom-headers/Auditor";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const MyAuditingPerformanceData = withLiteObserverAndTheme(() => {
  return (
    <React.Fragment>
      <Et3Table
        columns={AUDITOR_MY_AUDITING_PERFORMANCE_HEADERS}
        rows={getMyAuditingPerformanceStore().auditPerformanceOrdered.get()}
        title={i18n.get("AUDIT_PERFORMANCE")}
        shouldBeFlagged={false}
        titleKey={"AUDITING_PERFORMANCE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={AUDITOR_MY_AUDITING_PERFORMANCE_EFFICIENCY}
        rows={getMyAuditingPerformanceStore().getEfficiencyData()}
        title={i18n.get("AUDIT_EFFICIENCY")}
        shouldBeFlagged={false}
        titleKey={"AUDITING_EFFICIENCY"}
      />
    </React.Fragment>
  );
});

export default MyAuditingPerformanceData;
